import { createGlobalStyle } from 'styled-components'

import { theme } from './theme'

/*body {
    color: ${props => (props.whiteColor ? 'white' : 'black')};
  }*/

/* Font handled in App.scss, cause otherwise we get font rendering problems
// Open Sans
import FontOpenSansBold from './../assets/fonts/OpenSans-Bold.ttf'
import FontOpenSansRegular from './../assets/fonts/OpenSans-Regular.ttf'
import FontOpenSansSemiBold from './../assets/fonts/OpenSans-SemiBold.ttf'
// PT Serif
import FontPTSerifBold from './../assets/fonts/PTSerif-Bold.ttf'
import FontPTSerifBoldItalic from './../assets/fonts/PTSerif-BoldItalic.ttf'
import FontPTSerifRegular from './../assets/fonts/PTSerif-Regular.ttf'
import FontPTSerifItalic from './../assets/fonts/PTSerif-Italic.ttf'
@font-face {
    font-style: normal;
    font-weight: normal;
    font-family: 'PT Serif';
    src: local('PT Serif Regular'), url(${FontPTSerifRegular}) format("truetype");
  }

  @font-face {
    font-style: normal;
    font-weight: bold;
    font-family: 'PT Serif';
    src: local('PT Serif Bold'), url(${FontPTSerifBold}) format("truetype");
  }

  @font-face {
    font-style: italic;
    font-weight: normal;
    font-family: 'PT Serif';
    src: local('PT Serif Italic'), url(${FontPTSerifItalic}) format("truetype");
  }

  @font-face {
    font-style: italic;
    font-weight: bold;
    font-family: 'PT Serif';
    src: local('PT Serif Bold-Italic'), url(${FontPTSerifBoldItalic}) format("truetype");
  }

  @font-face {
    font-style: normal;
    font-weight: normal;
    font-family: 'Open Sans';
    src: local('Open Sans Regular'), url(${FontOpenSansRegular}) format("truetype");
  }

  @font-face {
    font-style: normal;
    font-weight: bold;
    font-family: 'Open Sans';
    src: local('Open Sans Bold'), url(${FontOpenSansBold}) format("truetype");
  }

  @font-face {
    font-style: normal;
    font-weight: 600; // 400 is normal
    font-family: 'Open Sans';
    src: local('Open Sans SemiBold'), url(${FontOpenSansSemiBold}) format("truetype");
  }*/

export const GlobalStyle = createGlobalStyle`

  @keyframes fadein {
    0% {
      opacity: 0;
    }
    100% {
      opacity: 1;
    }
  }

  body {
    background-color: ${theme.colorBackgroundBeige2};
    min-width: 320px; // we want our header font to don't break
    min-height: ${theme.minHeight}px;
    height: 100vh;
    height: fill-available; // does not work in firefox and safari currently, thus we use library Div100vh
    max-width: ${theme.contentMaxWidth}px;
    margin: 0 auto;
    font-size: 16px;
    //font-family: 'Open Sans', sans-serif; // done in globalStyle.tsx
    //-webkit-font-smoothing: antialiased; // done in globalStyle.tsx
    //-moz-osx-font-smoothing: grayscale; // done in globalStyle.tsx
    display: flex;
    flex-direction: column;
    // --------------- for pixel perfekt -----------
    //min-width: 360px; // for pixel perfekt
    //min-height: 660px; // for pixel perfekt
    //width: 360px; // for pixel perfekt
    //height: 660px; // for pixel perfekt
    //margin: 0; // for pixel perfekt
    //border: 1px solid red; // for pixel perfekt
    //#root {
    //  > div > div {
    //    height: 660px !important; // for pixel perfekt
    //  }
    //}
  }


  code {
    font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',
    monospace;
  }

  :root {
    --white: #fff;
    --active-color: #00aeb0;
  }

  #root {
    flex: 1; // flex: 1 will have the remaining full space given to it, all other elements will have the same height as their content
    overflow: scroll;
  }

  main {
    position: relative;
    height: calc(100% - 48px); /* heather == 48px */
    //border: 1px solid blue;
  }

  * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
  }

  html {
    font-family: 'Open Sans', 'Noto Sans JP', 'Hiragino Sans', 'Yu Gothic', 'Malgun Gothic', 'Apple SD Gothic Neo', Arial, Helvetica, sans-serif;
    height: fill-available;
  }

  button {
    background: none;
    border: none;
    cursor: pointer;
  }


`
